import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { EnvironmentService } from './environment.service';

export type PersistenceConsentType = 'technical'|'analytics'|'technical_third_party'

export type PersistenceConsentData = Partial<Record<PersistenceConsentType, boolean>>

export class PersistenceConsentConfig { 
    id:PersistenceConsentType; 
    required?:boolean; 
}

@Injectable({
  providedIn: 'root'
})
export class PersistenceService {

    constructor(private environmentService:EnvironmentService) { }

    isActive = false;
    needConsent = false;

    consentDataChange = new Subject<PersistenceConsentData>();
    consentReviewRequest = new Subject<void>();

    consentData:PersistenceConsentData = null
    consentConfig:Array<PersistenceConsentConfig> = [{
        id: 'technical',
        required: true
    },{
        id: 'technical_third_party'
    },{
        id: 'analytics'
    }]

    private _skipConsent() {
        return this.environmentService.ElectronWrapper || this.environmentService.environment.AppMode == 'kiosk'
    }

    isConsentAvailable() {
        return !this._skipConsent()
    }

    requestConsentReview() {
        if(this.isConsentAvailable()) {
            this.consentReviewRequest.next()
        }
    }

    activate(options?: { requireTechnicalThirdParty?: boolean }) {
        this.isActive = true;

        if(options?.requireTechnicalThirdParty) {
            for(let _config of this.consentConfig) {
                if(_config.id == 'technical_third_party') {
                    _config.required = true;
                }
            }
        }

        if(this._skipConsent()) {
            this.needConsent = false;

            this.consentData = {}

            for(let _config of this.consentConfig) {
                this.consentData[_config.id] = true;
            }
        }
        else {
            localStorage.removeItem('PGPersistenceConsent')
            let _savedConsent = localStorage.getItem('PGPersistenceConsentV2')

            if(_savedConsent != null) {
                this.consentData = JSON.parse(_savedConsent)
            }
            else {
                this.consentData = {}
            }

            for(let _config of this.consentConfig) {
                if(this.consentData[_config.id] == undefined) {
                    // Also for optional types (e.g. technical_third_party): if never
                    // explicitly set, show the popup so the user chooses true/false.
                    this.needConsent = true;
                }
                else if(_config.required && !this.consentData[_config.id]) {
                    this.needConsent = true;
                }
            }
        }
    }

    hasConsentFor(id:PersistenceConsentType) {
        if(this._skipConsent()) {
            return true;
        }
        else {
            return !this.isActive || this.consentData[id];
        }
    }

    saveConsent(consentData:PersistenceConsentData) {
        let _normalizedConsent:PersistenceConsentData = {}

        for(let _config of this.consentConfig) {
            _normalizedConsent[_config.id] = !!consentData[_config.id]
        }

        localStorage.setItem('PGPersistenceConsentV2', JSON.stringify(_normalizedConsent))
        this.consentData = _normalizedConsent;
        this.consentDataChange.next(this.consentData)

        setTimeout(() => {
            window.location.reload()
        }, 100)
    }

    // TODO: per ora gestisce solo con local storage

    persistenceStorage = 'localStorage';

    setItem(key:string, val:string, checkConsent:PersistenceConsentType) {
        if(checkConsent == null || this.hasConsentFor(checkConsent)) {
            try {
                localStorage.setItem(key, val)
            }
            catch(ex) {
                console.error(ex)
            }
        }
    }

    getItem(key:string) {
        try {
            return localStorage.getItem(key)
        }
        catch(ex) {
            console.error(ex)
            return null;
        }
    }

    removeItem(key:string) {
        try {
            localStorage.removeItem(key)
        }
        catch(ex) {
            console.error(ex)
        }
    }
}
